import(/* webpackMode: "eager", webpackExports: ["Consola"] */ "/vercel/path0/src/app/(marketing)/components/v5/consola.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(marketing)/components/v5/constellation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavV5"] */ "/vercel/path0/src/app/(marketing)/components/v5/nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Red"] */ "/vercel/path0/src/app/(marketing)/components/v5/red.tsx");
